import { render, staticRenderFns } from "./distributionCheck.vue?vue&type=template&id=0254c891&scoped=true"
import script from "./distributionCheck.vue?vue&type=script&lang=js"
export * from "./distributionCheck.vue?vue&type=script&lang=js"
import style0 from "./distributionCheck.vue?vue&type=style&index=0&id=0254c891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254c891",
  null
  
)

export default component.exports